/**
 * PHCapture - punto UNICO de captacion de PadelHouse (e-Growth).
 * v3, 2026-08-19: fuera fetch(); se envia con un <form> real oculto a un iframe.
 *
 * POR QUE. Shopify protege /contact y nunca acepta un POST hecho con fetch():
 * con la proteccion antispam ACTIVADA exige un token de hCaptcha, y DESACTIVADA
 * exige un `form_key`. Las dos cosas las inyecta su script (captcha-bootstrap)
 * SOLO al dispararse un evento `submit` de verdad, y fetch() no lo dispara. Por
 * eso todo moria en 400: "Missing CAPTCHA token" con la proteccion puesta,
 * "invalid parameters" sin ella. Verificado en vivo el 2026-08-19.
 *
 * COMO. Form oculto -> Shopify.captcha.protect() -> clic en su boton. Al ser un
 * submit real, Shopify le pone lo que toque. Va a un iframe invisible, asi que
 * la pagina no recarga; y como es del mismo origen, LEEMOS el resultado.
 *
 * Uso: PHCapture.enviar({ email, consent, tipo, cuerpo }) -> Promise
 * Rechaza con Error('email') / Error('consent') / Error('envio-<motivo>').
 * Quien llama DEBE tratar el rechazo: sin catch, el usuario ve un "listo" falso.
 * OJO: el tag se compone como 'ph-' + tipo. Pasa 'producto-faltante', no
 * 'ph-producto-faltante', o sale 'ph-ph-...'.
 */
(function () {
  'use strict';
  if (window.PHCapture) return;

  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/').replace(/\/$/, '');
  // Destino minusculo a proposito: sin return_to, el iframe cargaria la pagina
  // entera y volveria a ejecutar dentro analitica, pixeles y popups.
  var VUELTA = ROOT + '/cart.js';
  var ESPERA_CAPTCHA = 8000;
  var ESPERA_RESPUESTA = 20000;
  var contador = 0;

  function campo(form, nombre, valor) {
    var input = document.createElement('input');
    input.type = 'hidden';
    input.name = nombre;
    input.value = valor;
    form.appendChild(input);
  }

  // Shopify expone captcha.protect(form, cb) justo para esto: enganchar hCaptcha
  // a un form que no estaba en el HTML inicial. Su bootstrap solo lo hace al
  // primer focus/change de un campo, y aqui no hay nadie que enfoque nada.
  function preparar(form) {
    return new Promise(function (listo) {
      var captcha = window.Shopify && window.Shopify.captcha;
      if (!captcha || typeof captcha.protect !== 'function') return listo();
      var hecho = false;
      var seguir = function () {
        if (hecho) return;
        hecho = true;
        listo();
      };
      try {
        captcha.protect(form, seguir);
      } catch (e) {
        return seguir();
      }
      setTimeout(seguir, ESPERA_CAPTCHA);
    });
  }

  function enviarCampos(datos, sinVuelta) {
    return new Promise(function (resolve, reject) {
      contador += 1;
      var destino = 'ph-capture-' + contador;
      var oculto = 'position:absolute;left:-9999px;top:0;width:1px;height:1px;border:0;overflow:hidden';

      var iframe = document.createElement('iframe');
      iframe.name = destino;
      iframe.title = 'Envio de formulario';
      iframe.setAttribute('aria-hidden', 'true');
      iframe.setAttribute('tabindex', '-1');
      iframe.style.cssText = oculto;

      var form = document.createElement('form');
      form.method = 'post';
      form.action = ROOT + '/contact';
      form.acceptCharset = 'UTF-8';
      form.target = destino;
      form.setAttribute('aria-hidden', 'true');
      form.style.cssText = oculto;

      Object.keys(datos).forEach(function (nombre) {
        campo(form, nombre, datos[nombre]);
      });
      if (!sinVuelta) campo(form, 'return_to', VUELTA);

      var boton = document.createElement('button');
      boton.type = 'submit';
      boton.tabIndex = -1;
      form.appendChild(boton);

      document.body.appendChild(iframe);
      document.body.appendChild(form);

      var cerrado = false;
      var reloj;

      function cerrar(error) {
        if (cerrado) return;
        cerrado = true;
        clearTimeout(reloj);
        if (form.parentNode) form.parentNode.removeChild(form);
        setTimeout(function () {
          if (iframe.parentNode) iframe.parentNode.removeChild(iframe);
        }, 0);
        if (error) reject(error);
        else resolve();
      }

      iframe.addEventListener('load', function () {
        var url;
        try {
          url = iframe.contentWindow.location.href;
        } catch (e) {
          // Si deja de ser mismo origen no podemos leer el resultado. Antes que
          // mentir con un "listo", lo damos por fallido.
          return cerrar(new Error('envio-ilegible'));
        }
        if (!url || url === 'about:blank') return;
        // Shopify SOLO añade *_posted=true cuando ha aceptado. Cualquier otra
        // cosa (su challenge, "invalid parameters", un 4xx) es fallo, por muy
        // 200 que venga.
        if (url.indexOf('_posted=true') !== -1) return cerrar();
        var titulo = '';
        try {
          titulo = (iframe.contentDocument && iframe.contentDocument.title) || '';
        } catch (e) {}
        var motivo = titulo.replace(/\s+/g, ' ').trim().slice(0, 40) || 'rechazado';
        // Sin esto el motivo real solo viaja dentro del Error y cada UI pinta su mensaje
        // generico: nadie llega a saber si fue el captcha, un 4xx o el throttle.
        console.error('[PHCapture] Shopify ha rechazado el envio. Motivo:', motivo, '| URL de vuelta:', url);
        cerrar(new Error('envio-' + motivo));
      });

      reloj = setTimeout(function () {
        cerrar(new Error('envio-sin-respuesta'));
      }, ESPERA_RESPUESTA);

      preparar(form).then(function () {
        if (!cerrado) boton.click();
      });
    });
  }

  // Un reintento sin return_to por si Shopify no aceptase ese destino. Solo se
  // reintenta cuando el envio ha fallado, o sea cuando no se ha creado nada:
  // no puede duplicar un registro.
  function enviarFormulario(datos) {
    /* Desde el 2026-08-20 el envio bueno es el formulario DONANTE de ph-forms.js: un
       {% form %} nativo, con su form_key, que Liquid pinta en todas las paginas. El
       form que monta este archivo a mano NO lo acepta Shopify con el captcha activo
       (medido: cero capturas desde que existe). Se deja debajo como red de seguridad
       por si ph-forms.js no hubiera cargado. */
    if (window.PHForms && typeof window.PHForms.enviarCampos === 'function') {
      return window.PHForms.enviarCampos(datos);
    }
    return enviarCampos(datos).catch(function (error) {
      if (/challenge|sin-respuesta|ilegible/i.test(error.message)) throw error;
      return enviarCampos(datos, true);
    });
  }

  function suscribir(opts) {
    opts = opts || {};
    var email = String(opts.email || '').trim();
    if (!email || email.indexOf('@') === -1) return Promise.reject(new Error('email'));
    return enviarFormulario({
      form_type: 'customer',
      utf8: '✓',
      'contact[email]': email,
      'contact[accepts_marketing]': 'true',
      'contact[tags]': opts.tags || ''
    });
  }

  function enviar(opts) {
    opts = opts || {};
    var email = String(opts.email || '').trim();
    if (!email || email.indexOf('@') === -1) return Promise.reject(new Error('email'));
    if (!opts.consent) return Promise.reject(new Error('consent'));
    var tipo = opts.tipo || 'captura';

    // El mensaje a la bandeja es el que ENTREGA lo que ha pedido el usuario (que
    // pala buscaba, que lista queria): si falla, falla todo y la UI lo dice. El
    // alta de cliente solo sirve para segmentar, asi que va DESPUES y sin
    // bloquear, para no hacerle esperar una segunda navegacion de iframe. Uno
    // detras de otro, no a la vez, para no comerse el throttle de /contact.
    /* Los dos envios cuentan, y por eso se espera a los dos.

       Hasta el 2026-08-20 el alta de cliente iba suelta y con el error tragado: si
       entraba el mensaje a la bandeja pero no el alta, la pantalla decia "listo" y el
       lead no existia en ninguna parte. Justo el fallo que se supone que arregla este
       archivo, repetido un escalon mas abajo.

       Van uno detras de otro, no a la vez, para no comerse el throttle de /contact. */
    return enviarFormulario({
      form_type: 'contact',
      utf8: '✓',
      'contact[email]': email,
      'contact[body]': '[' + tipo.toUpperCase() + ']\n' + (opts.cuerpo || '')
    }).then(
      function () {
        return suscribir({ email: email, tags: 'ph-' + tipo }).catch(function (error) {
          console.error('[PHCapture] el mensaje SI entro, pero el alta de cliente NO:', error.message);
          throw new Error('alta-' + error.message);
        });
      },
      function (error) {
        console.error('[PHCapture] no ha entrado el mensaje:', error.message);
        throw error;
      }
    );
  }

  window.PHCapture = { enviar: enviar, suscribir: suscribir, enviarCampos: enviarCampos };
})();
